// Rilevamento client-side di dati personali riconoscibili prima dell'invio in chat.
// Non blocca: mostra un avviso. Si registra solo il TIPO rilevato, mai il dato.

const EMAIL_RX = /[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}/g;

export const SENSITIVE_PATTERNS = [
  { id: "codice_fiscale", label: "Codice fiscale", rx: /\b[A-Za-z]{6}\d{2}[A-Za-z]\d{2}[A-Za-z]\d{3}[A-Za-z]\b/ },
  { id: "iban", label: "IBAN", rx: /\b[A-Z]{2}\d{2}[A-Za-z0-9]{11,30}\b/ },
  { id: "carta", label: "Numero di carta", rx: /\b(?:\d{4}[ -]){3}\d{2,4}\b|\b\d{13,19}\b/ },
  { id: "partita_iva", label: "Partita IVA", rx: /\b(?:IT\s?)?\d{11}\b/ },
];

export function detectSensitiveData(text) {
  const t = text || "";
  const hits = [];
  const seen = new Set();
  for (const p of SENSITIVE_PATTERNS) {
    if (p.rx.test(t) && !seen.has(p.id)) {
      seen.add(p.id);
      hits.push({ id: p.id, label: p.label });
    }
  }
  const emails = t.match(EMAIL_RX) || [];
  if (new Set(emails.map((e) => e.toLowerCase())).size >= 3) {
    hits.push({ id: "email_massive", label: "Elenco di indirizzi email (3 o più)" });
  }
  return hits;
}
